const DRAWER_WIDTH = 400;

export { DRAWER_WIDTH };
